import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRetakeAvailable, fetchTaxProfile, fetchAccountStatus } from '../actions/tax.actions';
import { selectTaxProfileState } from '../selectors/tax.selector';
import { useContentGate } from './useContentGate';
import { GAME_TITLE } from '../constants/GameTitle';

export const useCompetitive = () => {
    const dispatch = useDispatch();
    const taxProfileState = useSelector(selectTaxProfileState);
    const { showEntitlementError } = useContentGate(GAME_TITLE.FORTNITE);
    useEffect(() => {
        if (!taxProfileState?.fetchedTaxProfile && !showEntitlementError) {
            dispatch(fetchRetakeAvailable() as any);
            dispatch(fetchAccountStatus() as any);
            dispatch(fetchTaxProfile() as any);
        }
    }, [dispatch]);
};
